var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate"},[_c('img',{attrs:{"src":require("./img/certificate2.jpeg"),"alt":""}}),_c('img',{attrs:{"src":require("./img/certificate3.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }